import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

/** Embedded item data within a user-item resource */
export interface UserItemEmbed {
  id: string;
  name: string;
  type: string;
  externalId: string | null;
  externalSource: string | null;
  thumbnailUrl: string | null;
  enrichedData: Record<string, unknown> | null;
  emoji: string | null;
  language: string | null;
}

/** Tag reference from user-item relationships */
export interface TagRef {
  type: string;
  id: string;
}

export type UserItem = WithLegacy<{
  status: string | null;
  dismissedAt: string | null;
  dismissedBy: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  item: UserItemEmbed | null;
  tags: TagRef[];
  [Type]: 'user-items';
}>;

export const UserItemSchema = withDefaults({
  type: 'user-items',
  fields: [
    { name: 'status', kind: 'attribute', type: 'string' },
    { name: 'dismissedAt', kind: 'attribute', type: 'string' },
    { name: 'dismissedBy', kind: 'attribute', type: 'string' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
    { name: 'updatedAt', kind: 'attribute', type: 'string' },
    { name: 'item', kind: 'attribute', type: 'object' },
    {
      name: 'tags',
      kind: 'hasMany',
      type: 'tags',
      options: { async: true, inverse: null },
    },
  ],
});
